import React from "react";

interface ButtonProps {
  href?: string;
  children: React.ReactNode;
  variant?: "primary" | "secondary";
  className?: string;
  onClick?: () => void;
}

export function Button({ 
  href, 
  children, 
  variant = "primary", 
  className = "",
  onClick 
}: ButtonProps) {
  const base = "rounded-xl px-4 py-2 transition-colors";
  const tone = variant === "secondary" 
    ? "border border-gray-300 hover:bg-gray-50" 
    : "bg-black text-white hover:bg-gray-800";
  const cls = `${base} ${tone}${className ? ` ${className}` : ""}`;
  
  if (href) {
    return <a href={href} className={cls}>{children}</a>;
  }
  
  return (
    <button onClick={onClick} className={cls}>
      {children}
    </button>
  );
}

export default Button;